import {
    BaseLayer,
    BaseLayerFactory_3857,
    BaseLayerType
} from "@esdm/map";

import { IBaseLayer } from "@esdm/map/dist/baselayers/interfaces/IBaseLayer";
import TileLayer from "ol/layer/Tile";
import TileWMS from 'ol/source/TileWMS';

import * as olProj from 'ol/proj';
import proj4 from "proj4";
import { register } from 'ol/proj/proj4';
import Projection from "ol/proj/Projection";
import XYZ from 'ol/source/XYZ';
import OSM from 'ol/source/OSM';
import ImageLayer from "ol/layer/Image";
import ImageWMS from 'ol/source/ImageWMS';
import WMTS from 'ol/source/WMTS'; 
import WMTSTileGrid from 'ol/tilegrid/WMTS';

import { get as getProjection } from "ol/proj";
import { getWidth } from "ol/extent";
import TileGrid from "ol/tilegrid/TileGrid"

export const SuffolkBaseLayerTypes = {
    ...BaseLayerType,
    SuffolkAerial: 998,
    SuffolkOS: 999
};

export class SuffolkBaseMapping_3857 extends BaseLayerFactory_3857 {

    public GetBaseLayerByType(baseLayerType: BaseLayerType, bingApiKey: string, esdmOsmApiKey:string): IBaseLayer {
        if (baseLayerType === SuffolkBaseLayerTypes.SuffolkOS) {
            return this.GetSuffolkOS();
        }

        if (baseLayerType === SuffolkBaseLayerTypes.SuffolkAerial) {
            return this.GetSuffolkAerial();
        }
        
        return super.GetBaseLayerByType(baseLayerType, bingApiKey, esdmOsmApiKey);
    }   

    private GetSuffolkOS(): IBaseLayer {
        
        const lyr = new TileLayer({
            extent: olProj.transformExtent([-7.68, 49.8, 1.77, 60.4], 'EPSG:4326', 'EPSG:3857'),
            preload: Infinity,
            source: new WMTS({
                //Configured via OGC Proxy
                url: "/api/OGCService/SuffolkOS",
                layer: "Road_3857",
                matrixSet: "EPSG:3857",
                format: "image/png",
                projection: "EPSG:3857",
                tileGrid: new WMTSTileGrid({
                    origin: [-20037508.342787, 20037508.342787],
                    resolutions: [1222.9924523698928, 611.4962261850814, 305.7481130924087, 152.87405654633633, 76.43702827303586, 38.21851413651793, 19.109257068258966, 9.554628534129483, 4.777314267197037, 2.3886571335985134, 1.1943285666669667, 0.5971642834657753, 0.2985821416005962, 0.1492910708002979],
                    matrixIds: ["EPSG:3857:7", "EPSG:3857:8", "EPSG:3857:9", "EPSG:3857:10", "EPSG:3857:11", "EPSG:3857:12", "EPSG:3857:13", "EPSG:3857:14", "EPSG:3857:15", "EPSG:3857:16", "EPSG:3857:17", "EPSG:3857:18", "EPSG:3857:19", "EPSG:3857:20"]
                }),
                style: "default",
                crossOrigin: "Anonymous",
                attributions: [`© Crown copyright. All rights reserved. Suffolk County Council Licence No. AC0000849963 ${new Date().getFullYear()}.`,
                    'Use of this data is subject to <a href = "/terms-and-conditions#os" >terms and conditions</a>.'],
            }),
            visible: false,
        });
        return new BaseLayer("SuffolkOS", "Ordnance Survey", lyr);
    } 

    private GetSuffolkAerial(): IBaseLayer {
        let lyr = new TileLayer({
            visible: false,
            source: new TileWMS({
                //Configured via OGC Proxy
                url: "/api/OGCService/SuffolkAerial",
                params: {
                    LAYERS: 'APGB_Latest_UK_125mm',
                    FORMAT: 'image/png',
                    SRS: 'EPSG:3857'
                },
                projection: "EPSG:3857",
                crossOrigin: "Anonymous",
                attributions: [`© Getmapping Plc and Bluesky International ${new Date().getFullYear()}`, ,
                    'Use of this data is subject to <a href="/terms-and-conditions#apgb">terms and conditions</a>']
            })
        });
        return new BaseLayer("SuffolkAerial", "Aerial Photography", lyr);
    }

    
}